package br.com.vvrefeicoes.portal.core.model

enum class ScreenMode {
    Read,
    Create,
    Edit,
}
